<template>
  <GenericWrapperChart :config="config">
    <template v-slot:afterChart>
      <span v-if="$store.state.ui.channel === 'Todas'">{{ message }}</span>
    </template>
  </GenericWrapperChart>
</template>

<script>
import { generateFileName } from '@/utils';

import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';

export default {
  name: 'SentimentsInTheComments',
  components: {
    GenericWrapperChart,
  },
  data() {
    return {
      title: 'Sentimento nos comentários',
      description: 'Sentimento dos comentários das publicações no período selecionado.',
      message: 'Os sentimentos dos comentários das publicações da rede social Instagram não estão inclusos nos gráficos. A API pública não fornece os comentários para análise.',
    };
  },
  computed: {
    overrideChartOptions() {
      const filename = generateFileName(this.title);

      return {
        exporting: {
          enabled: false,
          sourceWidth: 750,
          filename,
          chartOptions: {
            title: {
              text: this.title,
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.sentimentsInTheComments.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? this.description : '';
      const hasError = this.$store.state.charts.sentimentsInTheComments.hasError;
      const series = this.$store.state.charts.sentimentsInTheComments.data.series;
      const categories = this.$store.state.charts.sentimentsInTheComments.data.categories;

      return {
        componentName: 'SentimentsInTheComments',
        title,
        description,
        isLoading,
        hasError,
        isEmpty: false,
        onError: this.getChartData,
        requestOnMounted: this.getChartData,
        downloadMenu: {
          trackNameOnOpen: 'BM ExportSentimentsInTheComments Graph Open',
          trackNameOnDownload: 'BM ExportSentimentsInTheComments Graph Click',
        },
        chart: {
          type: 'BasicBar',
          series,
          categories,
          overrideChartOptions: this.overrideChartOptions,
          trackNameOnObserve: 'BM SentimentsInTheComments Graph View',
          trackNameOnLegendClick: 'BM SentimentsInTheComments LegendGraph View',
        },
      };
    },
  },
  methods: {
    async getChartData() {
      await this.$store.dispatch('charts/fetchSentimentsInTheComments');
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  display: flex;
  align-items: center;
  background-color: var(--ds-color--background);
  padding: var(--ds-spacing-inline-xs);
  border-radius: var(--ds-border-width-thick);
  color: var(--ds-color--text-1);
  font-size: var(--ds-font-size-xs);
  margin-left: var(--ds-spacing-inline-nano);
  margin-top: var(--ds-spacing-inline-xs);
}
</style>

